import styled from "styled-components";

export const BaseModalContainer = styled.div`
    background: ${(props) => props.theme.colors.neutral[100]};
    height: 80vh;
    width: 50vw;

    border-radius: 0.2rem;

    resize: both;

    display: flex;
    flex-flow: column;

    overflow: hidden;

    & > *:first-child {
        flex: 0 0 4rem;
    }

    & > *:nth-child(2) {
        flex: 1;
    }

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

export const BaseSubModalContainer = styled.form`
    display: flex;
    flex-flow: column;
    padding: 1rem;
    max-height: calc(100% - 4rem);
`;
